export { secp256k1 } from "@noble/curves/secp256k1";